import { useQuery } from '@tanstack/react-query';
import api from '@/lib/api';
import type { SharedTodoListResponse } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

interface UseTodoSharedReturn {
  sharedLists: SharedTodoListResponse[];
  loading: boolean;
  error: string | null;
}

export function useTodoShared(): UseTodoSharedReturn {
  const { data, isLoading, error } = useQuery({
    queryKey: queryKeys.todoLists.shared(),
    queryFn: () => api.getSharedTodoLists(),
  });

  return {
    sharedLists: data?.lists ?? [],
    loading: isLoading,
    error: error instanceof Error ? error.message : error ? 'Failed to load shared lists' : null,
  };
}
